import type { Fallacy } from "./types";
import { createStory } from "./types";

export const noTrueScotsman: Fallacy = {
    id: "no-true-scotsman",
    name: "No True Scotsman",
    emoji: "🏴",
    category: "Logika Rusak",
    description:
      "**Mengubah definisi** kelompok untuk **mengecualikan contoh yang membantah** klaim. 'Yang asli mah gak gitu.'",
    tldr: "Definisinya diubah-ubah biar klaimnya gak bisa dibantah? No True Scotsman.",
    detail:
      "No True Scotsman terjadi ketika seseorang membuat klaim umum tentang sebuah kelompok, lalu ketika ada contoh yang membantah, mereka **mengubah definisi kelompok** agar contoh tersebut 'tidak masuk hitungan'.\n\nPola: Klaim \"Semua X pasti Y\" → ada counter-example → \"Z bukan X yang SEJATI/ASLI.\"\n\nKenapa ini fallacy? Karena **definisi terus digeser** sehingga klaim jadi **tidak bisa dibantah** (unfalsifiable). Kalau definisi bisa berubah sesuka hati, argumen jadi kosong.",
    story: createStory("No True Scotsman", "🏴", {
      hook: {
        title: "Kamu kasih contoh yang membantah.",
        body: "Tapi orangnya langsung bilang: \"Ya itu mah bukan yang ASLI.\" Pernah?",
      },
      convo: {
        claim: "Programmer sejati itu passionate, gak kenal waktu kalau udah ngoding. Senior kamu pulang jam 5 tiap hari? **Ya berarti dia bukan programmer sejati.**",
        response: "Kodenya bagus, hasilnya oke. **Definisi \"sejati\" kamu cuma buat ngecualiin yang gak cocok.**",
      },
      reveal: {
        body: "Definisinya **diubah-ubah sesuka hati** biar klaimnya gak bisa dibantah. Setiap kali ada contoh yang ngebantah, langsung dikecualikan.",
      },
      insight: {
        title: "Kenapa ini masalah?",
        body: "Kalau definisi bisa **diubah sesuka hati**, klaim kamu gak bisa salah — dan argumen yang gak bisa salah itu sebenernya kosong.",
      },
      engagement: {
        title: "Pernah denger \"yang asli mah gak gitu\" buat ngecualiin contoh yang gak cocok?",
        body: "Fans bola, programmer, atau \"anak muda beneran\"? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["circular-reasoning", "straw-man", "hasty-generalization"],
  };
